import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import API from "../lib/api";
import { BrandMark } from "./AuthLayout";
import { useAppT, LanguageToggle } from "../components/home/i18n";

const TITLES = { terms: "Terms of Service", privacy: "Privacy Policy", guidelines: "Community Guidelines" };

export default function Legal({ docKey }) {
  const params = useParams();
  const doc = docKey || params.doc;
  const { a, lang } = useAppT();
  const [data, setData] = useState(null);
  useEffect(() => {
    setData(null);
    API.get(`/legal/${doc}`, { params: { lang } }).then(({ data }) => setData(data)).catch(() => setData(false));
  }, [doc, lang]);

  return (
    <div className="min-h-screen bg-[#FDFBF7]">
      <header className="border-b border-[#E8E4DB] bg-white">
        <div className="mx-auto flex max-w-3xl items-center justify-between gap-2 px-5 py-3">
          <BrandMark />
          <div className="flex items-center gap-3">
            <LanguageToggle testid="legal-lang-toggle" variant="dark" />
            <Link to="/" className="text-sm text-[#1F4A38]">{a.legal.home}</Link>
          </div>
        </div>
      </header>
      <div className="mx-auto max-w-3xl px-5 py-10" data-testid={`legal-${doc}`}>
        {data === false ? <p className="text-sm text-[#8B3A3A]">{a.legal.notFound}</p> : !data ? <p className="text-sm text-[#8a8580]">{a.legal.loading}</p> : (
          <>
            <h1 className="font-serif text-4xl text-[#173A2C]">{data.title || TITLES[doc]}</h1>
            <div className="mt-1 text-xs text-[#8a8580]">{a.legal.version} {data.version}</div>
            <div className="mt-3 rounded-sm border border-[#C4A46B]/40 bg-[#C4A46B]/10 p-3 text-xs text-[#8a6f38]" data-testid="legal-disclaimer">{data.disclaimer}</div>
            <pre className="mt-6 whitespace-pre-wrap font-sans text-sm leading-relaxed text-[#2C2A29]">{data.body}</pre>
          </>
        )}
      </div>
    </div>
  );
}
